'use strict';

var reactIs = {exports: {}};

exports.__module = reactIs;
//# sourceMappingURL=index5.cjs.map
